import { Link } from "react-router-dom";

const HERO_IMG = "https://images.unsplash.com/photo-1509391366360-2e959784a276?auto=format&fit=crop&w=1600&q=80";

export default function Home() {
  return (
    <div data-testid="home-page">
      {/* Hero */}
      <section className="section pt-12 md:pt-20">
        <div className="container-x grid md:grid-cols-2 gap-12 items-center">
          <div>
            <p className="tag">Nettoyage de panneaux solaires · France</p>
            <h1 className="text-[40px] md:text-[56px] leading-[1.05] font-bold text-[#0F1A2A]">
              Vos panneaux solaires, propres et performants.
            </h1>
            <p className="mt-6 text-[17px] text-[#1F2A3D] max-w-lg">
              Nous nettoyons vos panneaux photovoltaïques à l'eau pure osmosée, sans produit
              chimique et sans monter sur votre toit. Vous récupérez jusqu'à 20 % de production.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/contact" data-testid="hero-cta-devis" className="btn btn-primary">
                Demander un devis gratuit
              </Link>
              <Link to="/methode" data-testid="hero-cta-methode" className="btn btn-outline">
                Voir notre méthode
              </Link>
            </div>
          </div>
          <div>
            <img src={HERO_IMG} alt="Panneaux solaires" className="w-full h-[380px] md:h-[460px] object-cover rounded-md" />
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="border-t border-[#E6E4DF]">
        <div className="container-x py-10 grid grid-cols-2 md:grid-cols-4 gap-8 text-center md:text-left">
          <div><p className="text-2xl font-bold">2 000+</p><p className="text-sm text-[#6B7280] mt-1">Panneaux entretenus</p></div>
          <div><p className="text-2xl font-bold">700+</p><p className="text-sm text-[#6B7280] mt-1">Interventions</p></div>
          <div><p className="text-2xl font-bold">+20 %</p><p className="text-sm text-[#6B7280] mt-1">Rendement récupéré</p></div>
          <div><p className="text-2xl font-bold">0</p><p className="text-sm text-[#6B7280] mt-1">Produit chimique</p></div>
        </div>
      </section>

      {/* Pourquoi nettoyer */}
      <section className="section bg-[#F6F4EF] border-t border-[#E6E4DF]">
        <div className="container-x">
          <p className="tag">Pourquoi nettoyer ?</p>
          <h2 className="h-title max-w-2xl">
            Un panneau encrassé peut perdre jusqu'à 25 % de production.
          </h2>
          <p className="mt-5 text-[#1F2A3D] max-w-2xl">
            La pluie ne nettoie pas vos panneaux : elle dépose et cristallise les salissures.
            Un entretien annuel protège votre installation et préserve la garantie constructeur.
          </p>

          <div className="mt-12 grid md:grid-cols-3 gap-8">
            <Item t="Pollens et lichens" d="Au printemps, les pollens collants forment une croûte qui favorise les lichens sur les cadres." />
            <Item t="Sable et pollution" d="Les épisodes de poussières sahariennes créent une pellicule abrasive que la pluie cristallise." />
            <Item t="Fientes d'oiseaux" d="Très acides, elles dégradent le revêtement antireflet et peuvent provoquer des hotspots." />
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="section border-t border-[#E6E4DF]">
        <div className="container-x">
          <p className="tag">Nos prestations</p>
          <h2 className="h-title">Ce que nous faisons</h2>

          <ul className="mt-12 grid md:grid-cols-2 gap-y-8 gap-x-12 max-w-4xl">
            {[
              ["Nettoyage à l'eau pure osmosée", "Filtration 0 ppm, sans produit chimique. Le seul traitement validé par les fabricants."],
              ["Démoussage doux", "Élimination des mousses et lichens sans rayer ni altérer les revêtements."],
              ["Inspection visuelle", "Détection des micro-fissures, hotspots et défauts d'étanchéité."],
              ["Maintenance annuelle", "Contrat préventif pour conserver un rendement nominal toute l'année."],
              ["Rapport d'intervention", "Photos avant/après et préconisations envoyées par mail."],
              ["Intervention depuis le sol", "Perches en fibre de carbone jusqu'à 15 m, aucun poids sur la toiture."],
            ].map(([t, d]) => (
              <li key={t}>
                <p className="font-semibold text-[#0F1A2A]">{t}</p>
                <p className="text-[#6B7280] mt-2 text-[15px]">{d}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* CTA */}
      <section className="section bg-[#0F1A2A] text-white">
        <div className="container-x flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold leading-tight">Un devis ? Une question ?</h2>
            <p className="text-white/70 mt-3">Réponse sous 24 h ouvrées, sans engagement.</p>
          </div>
          <Link to="/contact" data-testid="cta-final" className="btn btn-light">
            Nous contacter
          </Link>
        </div>
      </section>
    </div>
  );
}

function Item({ t, d }) {
  return (
    <div>
      <p className="font-semibold text-[#0F1A2A]">{t}</p>
      <p className="text-[15px] text-[#6B7280] mt-2">{d}</p>
    </div>
  );
}
